const envApiBaseUrl = import.meta.env.LH_TIMP_API_BASE_URL
const envAgGridApiBaseUrl = import.meta.env.LH_TIMP_AG_GRID_API_BASE_URL
const apiBaseUrlOverride = localStorage.getItem('lhApiBase')
const agGridApiBaseUrlOverride = localStorage.getItem('lhAGGridApiBase')

export const API_BASE_URL = apiBaseUrlOverride ?? envApiBaseUrl

export const AG_GRID_API_BASE_URL =
  agGridApiBaseUrlOverride ?? envAgGridApiBaseUrl
